(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
/* Logo-list: 트랙 자동탐색 → CSS 키프레임 강제 → 마지막 수단 rAF 티커 */
(function(){
  function $all(root, sel){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function eagerImages(scope){
    $all(scope,'img').forEach(function(img){
      var src = img.getAttribute('data-original') || img.getAttribute('data-src') || img.getAttribute('src') || '';
      if (!src) return;
      if (src.indexOf('{width}') !== -1) src = src.replace('{width}','800'); // 640~800 권장
      if (src.startsWith('//')) src = (location.protocol || 'https:') + src;
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.classList.remove('lazyload','lazyloaded','lazyautosizes','ls-is-cached','no-js-hidden');
      img.loading = 'eager'; img.decoding = 'async'; img.src = src;
    });
  }

  // multi-logo-wrapper 아래에서 "직접 자식으로 .multi-logo-item를 여러 개 가진" 노드를 트랙으로 선정
  function findTrack(wrapper){
    if (!wrapper) return null;

    // 1) 직계 자식 중 다수의 logo-item을 가진 노드 우선
    var cand = $all(wrapper, '*').find(function(el){
      try {
        return el.querySelectorAll(':scope > .multi-logo-item').length >= 2;
      } catch(e) { return false; }
    });
    if (cand) return cand;

    // 2) 후순위: logo-item 전체를 가장 많이 포함하는 노드
    var best = null, max = 0;
    $all(wrapper, '*').forEach(function(el){
      var c = el.querySelectorAll('.multi-logo-item').length;
      if (c > max){ max = c; best = el; }
    });
    return best || wrapper;
  }

  function ensureTwoSets(track){
    if (!track || track.dataset.duplicated === '1') return;
    track.innerHTML += track.innerHTML; // 내부 복제 1회
    track.dataset.duplicated = '1';
  }

  function calcShift(section, track){
    // -100%/k 계산 (반복 단위 추정이 까다로우므로 최소 2세트 기준)
    var k = 2;
    section.style.setProperty('--marqueeShift', (-100 / k) + '%');
  }

  function forceCSS(track){
    track.classList.add('marquee-track');
    track.style.setProperty('animation-name','logosMarquee','important');
    track.style.setProperty('animation-duration','var(--loopSpeed,60s)','important');
    track.style.setProperty('animation-timing-function','linear','important');
    track.style.setProperty('animation-iteration-count','infinite','important');
    track.style.setProperty('animation-play-state','running','important');
    track.style.removeProperty('transform');
    track.style.willChange = 'transform';
  }

  function cssAlive(track, cb){
    var t0 = getComputedStyle(track).transform;
    setTimeout(function(){
      var st = getComputedStyle(track);
      var t1 = st.transform, an = (st.animationName||'');
      cb( (an.indexOf('logosMarquee') !== -1 && t1 !== t0) || (t1 !== 'none' && t1 !== t0) );
    }, 250);
  }

  function startTicker(section, track){
    var half = track.scrollWidth / 2;
    if (!half) return;
    var speed = half / dur; // px/s
    var start=null, paused=false;
    function step(ts){
      if (start==null) start = ts;
      var dx = (((ts-start)/1000)*speed) % half;
      track.style.setProperty('animation','none','important');
      track.style.setProperty('transform','translate3d('+(-dx)+'px,0,0)','important');
      requestAnimationFrame(step);
    }
    track.addEventListener('mouseenter', function(){ paused=true; });
    track.addEventListener('mouseleave', function(){ paused=false; });
    requestAnimationFrame(step);
  }

  function initOne(section){
    if (!section || section.dataset.logoInit === '1') return;

    // 테마 마키 속성 제거
    var wrap = section.querySelector('.multi-logo-wrapper');
    if (wrap){
      wrap.removeAttribute('data-scrolling-content');
      wrap.removeAttribute('data-scrolling-speed');
    }

    // wrapper가 없을 경우, 네가 준 셀렉터로 보조 탐색
    if (!wrap){
      wrap = section.querySelector(':scope > div'); // #logo-list-... > div (container)
    }

    var track = findTrack(wrap);
    if (!track) return;

    // 이미지 즉시 로드 + 2세트 확보 + 이동량 변수
    eagerImages(track);
    ensureTwoSets(track);
    calcShift(section, track);

    // CSS 애니메이션 강제
    forceCSS(track);

    // 안 움직이면 JS 티커로 폴백
    cssAlive(track, function(alive){
      if (!alive) startTicker(section, track);
    });

    section.dataset.logoInit = '1';
  }

  function initAll(root){
    // 섹션 루트: data-section-type="logo-list" 또는 id^="logo-list-" 모두 지원
    var sections = $all(root||document, '.shopify-section[data-section-type="logo-list"], [id^="logo-list-"]');
    sections.forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target||document); });
})();

  } catch(e) { console.error(e); }
})();
})();
